export default __webpack_public_path__ + "static/review1-5fca71dec49968a610a8beefa1a8029e.png";